import { render } from "./employee.vue?vue&type=template&id=dca8b0ee&scoped=true"
import script from "./employee.vue?vue&type=script&lang=js"
export * from "./employee.vue?vue&type=script&lang=js"

import "./employee.vue?vue&type=style&index=0&id=dca8b0ee&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca8b0ee"]])

export default __exports__